import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AgingPeriodFacade } from './facades/aging-period.facade';
import { agingCacheReducers } from './view-cache-controller/store/reducers/root';
import { agingPeriodViewCacheFeatureKey } from './view-cache-controller/store/reducers/view-cache.reducers';
// import { AgingPeriodModule } from './aging-period.module';

export const agingCacheStoreModule = StoreModule.forFeature(agingPeriodViewCacheFeatureKey, agingCacheReducers.agingPeriodViewCache);

@NgModule({
  imports: [
    CommonModule,
    // AgingPeriodModule,
    agingCacheStoreModule
  ],
  providers: [
    AgingPeriodFacade
  ]
})
export class ViewCacheModule {}
